import { useTracking } from '@/hooks/useTracking'

// This component just initializes tracking - the hook handles everything
export const AnalyticsTracker = () => {
  useTracking()
  return null
}